export default "__VITE_ASSET__DlTuAWVw__"